import { TextBlockText, MediaBlockText } from '@/graphql/types'
import type { Document } from '@contentful/rich-text-types'

type RichTextResponse = TextBlockText | MediaBlockText
// import { getRenderOptions } from '@/components/rich-text'
import classes from './Tabs.module.css'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

interface TabContentProps {
  content: RichTextResponse
  index: number
  activeTab: number
}

export function TabContent({ content, index, activeTab }: TabContentProps) {
  return (
    <div
      role="tabpanel"
      id={`panel-${index}`}
      aria-labelledby={`tab-${index}`}
      hidden={activeTab !== index}
      className={classes.tabPanel}
    >
      {content ? documentToReactComponents(content.json as Document) : null}
    </div>
  )
}
